export const APP_VERSION_INLINE_DEFAULT_COLOR = 'text.secondary';
